import React from 'react';
import { useRecoilValue } from 'recoil';
import { lookupState, authenticationState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import IncorrectPartNumber from 'pages/NewCaseSearch/subcomponents/IncorrectPartNumber';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import RequestReview from 'pages/NewCaseSearch/subcomponents/RequestReview';
import { ProductPrice } from 'components/Product/styledComponents';
import { Flex } from 'components/layout/Flex';
import { FEE_NOT_ALLOWED_MESSAGE } from 'utils/constants';
import { useFormatPrice } from 'utils/hooks/useFormatPrice';

const OutOfWarranty = () => {
  const { lookupResults, selectedResult, reviewRequested } = useRecoilValue(lookupState);
  const { hasAllowFeePermission } = useRecoilValue(authenticationState);
  const formatPrice = useFormatPrice();
  const { serialNumber, product } = selectedResult;
  const serialCard = [{ title: 'Serial #:', value: serialNumber }];
  const reviewCard = [];
  const outOfWarrantyMessage = 'This item is not covered under warranty';
  const feesNotAllowedMessage = !hasAllowFeePermission && FEE_NOT_ALLOWED_MESSAGE;

  if (reviewRequested) {
    reviewCard.push({ title: 'Review Requested:', value: 'True' });
  }

  return (
    <Flex direction="column">
      {lookupResults.length === 1 ? (
        <Header
          cards={[...serialCard, ...reviewCard]}
          feesNotAllowedMessage={feesNotAllowedMessage}
        />
      ) : null}
      <Flex spacing="space-between">
        <Flex direction="column" spacing="space-between" grow="1">
          <Product statusMessage={outOfWarrantyMessage} {...product} />
          <RmaFiels />
        </Flex>
        <WarrantyActions>
          <ProductPrice>Repair Fee: {formatPrice(product.outOfWarrantyPrice)}</ProductPrice>
          <AddToRma />
          {lookupResults.length === 1 && !reviewRequested ? <IncorrectPartNumber /> : null}
          <RequestReview />
        </WarrantyActions>
      </Flex>
    </Flex>
  );
};

export default OutOfWarranty;
